import * as React from 'react'
import { withRouter, Link } from 'react-router-dom'
import * as cookie from 'js-cookie'
import SVG from 'react-inlinesvg'
import { History } from 'history'
import { COOKIES_AUTHORIZATION_TOKEN } from '@App/constantes'
import './styles.scss'
import FormatText from '@App/helpers/formatText'
import { Button } from 'relevant-ui'
// @ts-ignore
import imageBliinkPng from 'assets/image-bliink.png'
// @ts-ignore
import logoBliinkSvg from 'assets/logo-bliink.svg'
import { Alert } from 'reducers/types'

/* TODO : METTRE CLASS ERROR BOUNDARIES */

interface Props {
  alert: Alert
  history: History
  location: Location
}

class BaseLayout extends React.Component<Props> {
  constructor(props: any) {
    super(props)

    this.checkLoggedUser = this.checkLoggedUser.bind(this)
  }

  componentDidMount() {
    this.checkLoggedUser()
  }

  checkLoggedUser() {
    const { history } = this.props

    if (cookie.get(COOKIES_AUTHORIZATION_TOKEN)) {
      history.push('/home')
    }
  }

  render() {
    const { children } = this.props

    return (
      <div className="wrapper">
        <div className="wrapper__left">
          <Link to="/">
            <SVG
              src={FormatText.formatSVGBase64(logoBliinkSvg)}
              className="wrapper__left__logo"
            />
          </Link>
          <div className="wrapper__left__container">
            <div className="media">
              <img className="media__image" src={imageBliinkPng} />
            </div>
            <div className="wrapper__left__brand">
              <div className="brand">
                <h1 className="brand__title">We connect powerful images related to your brand.</h1>
                <p className="brand__subtitle">We deliver contextual ads on top of relevant editorial photos using our top-notch image recognition technology.</p>
              </div>
              <div className="wrapperButton">
                <Button
                  label="Learn More"
                  size="large"
                  button="default"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          {children}
        </div>
      </div>
    )
  }
}

export default withRouter(BaseLayout)
